<template src="./AnalisisDeFormulario.html"></template>
<script>
import Icono from "../Icono/Icono";
import SelectTree from "../SelectTree/SelectTree";
import EstadoDocumentos from "../EstadoDocumentos/EstadoDocumentos";
import {
  obtenerProgramas,
  obtenerEstadosPrograma,
  leerPacientesPrograma,
  obtenerColecciones,
  obtenerDocumentosColeccion,
  clasificarPacientes,
  variablesDocumento,
  analisisFormulario
} from "../../apiService/request/CrudAnalisisDeFormulario";
import DatePicker from "../DatePicker/Datepicker";
import mixinScroll from "../../js/mixins/mixinScroll";

export default {
  data() {
    return {
      datosGrafica: 0,
      mostrarTituloActual: true,
      valorCampo: "",
      tamanoPantalla: true,
      enviarMensajeCerrado: true,
      respuesta: {},
      selected: [],
      selectAll: false,
      indeterminateSelectAll: false,
      sort_desc: [],
      search: "",
      page: 1,
      items: [15, 25, 50, 100],
      itemsPerPage: 15,
      banderaTabla: false,
      headers: [],
      desserts: [],
      sort_by: [],
      tituloPadre: "",
      fechaInicial: "",
      fechaFinal: "",
      banderaMostrarSidebar: false,
      opcionesFiltros: [],
      programas: [],
      programaSeleccionado: null,
      // nombrePrograma: '',
      estadosPrograma: [],
      arrayEstadosSeleccionados: [],
      pacientesPrograma: [],
      colecciones: [],
      coleccionSeleccionada: null,
      estadoDocumentos: null,
      opcionesEstadoDocumentos: [
        { nombre: "Diligenciados", valor: "diligenciados" },
        { nombre: "No diligenciados", valor: "no_diligenciados" }
      ],
      categorizacion: { diligenciados: [], no_diligenciados: [] },
      iconoBot:
        "M22,0C9.9,0,0,9.9,0,22s9.9,22,22,22s22-9.9,22-22S34.1,0,22,0z M22,2c8,0,14.9,4.7,18.1,11.5C36.1,7.7,29.4,4,22,4C14.6,4,7.9,7.7,3.9,13.5C7.1,6.7,14,2,22,2z M41.6,22C39.7,31.3,31.5,38,22,38S4.3,31.3,2.4,22C4.3,12.7,12.5,6,22,6S39.7,12.7,41.6,22z M22,42c-8,0-14.9-4.7-18.1-11.5C7.9,36.3,14.6,40,22,40c7.4,0,14.1-3.7,18.1-9.5C36.9,37.3,30,42,22,42z M13,16c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S16.3,16,13,16z M13,26c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S15.2,26,13,26z M31,16c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S34.3,16,31,16z M31,26c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S33.2,26,31,26z",
      iconoBuscar:
        "M17.8,27.8c0,0.6-0.4,1-1,1c-6.7,0-12.1-5.4-12.1-12.1c0-0.6,0.4-1,1-1s1,0.4,1,1c0,5.6,4.5,10.1,10.1,10.1C17.3,26.8,17.8,27.3,17.8,27.8z M43.7,43.7C43.5,43.9,43.3,44,43,44s-0.5-0.1-0.7-0.3L27.8,29.3c-3,2.6-6.8,4.2-11.1,4.2C7.5,33.5,0,26,0,16.8S7.5,0,16.8,0s16.8,7.5,16.8,16.8c0,4.3-1.6,8.1-4.2,11.1l14.4,14.4C44.1,42.7,44.1,43.3,43.7,43.7zM16.8,31.5c8.1,0,14.8-6.6,14.8-14.8S24.9,2,16.8,2S2,8.6,2,16.8S8.6,31.5,16.8,31.5z",
      documentosEnColeccion: [],
      on: false,
      documentoSeleccionado: null,
      graficaKey: 0,
      variablesDocumento: [],
      arrayVariablesTabla: [],
      cantidaElementosMostrar: 0,
      variableSeleccionada: null,
      opciones: {
        chart: {
          width: "100%",
          type: "bar",
          stacked: true,
          toolbar: {
            show: false
          },
          events: {
            dataPointSelection: (event, chartContext, config) => {
              this.showTable(config.dataPointIndex);
            },
            click: (event, chartContext, config) => {
              if (
                event &&
                event.target &&
                (event.target.className === "apexcharts-legend-text" ||
                  event.target.className === "apexcharts-legend-series" ||
                  event.target.className === "apexcharts-legend-marker")
              ) {
                this.showTable(Number(event.target.getAttribute("rel")) - 1);
              }
            }
          }
        },
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "left",
          offsetX: 40
        },
        states: {
          active: {
            allowMultipleDataPointsSelection: false,
            filter: {
              type: "darken",
              value: 0.3
            }
          }
        },
        // colors: ['#3A5FBA', '#3D88C4', '#3F9AAE','#3DC4B9','#8DDFF2','#579FF2','#67C2EF','#7CD5CE'],
        // colors: ["#3A5FBA", "#3D88C4", "#3F9AAE"],
        colors: [
          "#579FF2",
          "#946EEB",
          "#90A4AE",
          "#F0706C",
          "#B7C53B",
          "#F38D89",
          "#D493B0",
          "#45B8DD",
          "#BA567C",
          "#3ABA8B",
          "#55669F",
          "#EFE18B",
          "#ED8432",
          "#F0AE7B"
        ],
        dataLabels: {
          textAnchor: "center",
          style: {
            colors: ["#fff"],
            fontSize: 15
          },
          offsetX: 0
        },
        grid: {
          row: {
            colors: ["#F4F5F8"]
          }
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              colors: ["#646a6f"],
              fontSize: "16px",
              fontFamily: "Nunito, sans-serif"
            },
            min: 20
          }
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light"
          }
        },
        plotOptions: {
          bar: {
            distributed: true,
            horizontal: true
          },
          colors: ["#3D88C4"]
        },
        yaxis: {
          labels: {
            show: false
          }
        }
      },
      series: []
    };
  },
  mixins: [mixinScroll],

  components: {
    Icono,
    SelectTree,
    DatePicker,
    EstadoDocumentos
  },
  async created() {
    await this.consultarProgramas();
  },
  computed: {
    arrayCedulas() {
      if (this.selected) {
        return this.selected.map(v => v.cedula);
      }
      return [];
    },
    diligenciados() {
      if (this.categorizacion && this.categorizacion.diligenciados) {
        return this.categorizacion.diligenciados;
      }
      return [];
    },
    pageCount() {
      return Math.ceil(this.desserts.length / this.itemsPerPage);
    },
    no_diligenciados() {
      if (this.categorizacion && this.categorizacion.no_diligenciados) {
        return this.categorizacion.no_diligenciados;
      }
      return [];
    }
  },
  watch: {
    selectAll(newValue, oldValue) {
      if (newValue) {
        this.selected = [];
        this.selected = this.desserts;
      } else {
        this.selected = [];
      }
    },
    selected(newValue, oldValue) {
      if (newValue) {
        if (newValue.length > 0 && newValue.length === this.desserts.length) {
          this.indeterminateSelectAll = false;
          this.selectAll = true;
        } else if (newValue.length > 0) {
          this.indeterminateSelectAll = true;
        } else {
          this.indeterminateSelectAll = false;
          this.selectAll = false;
        }
      }
    }
  },
  methods: {
    actualizaGrafica() {
      this.datosGrafica += 1;
    },
    verBoton() {
      this.enviarMensajeCerrado = true;
      this.tamanoPantalla = true;
      setTimeout(() => {
        this.datosGrafica += 1;
      }, 500);
    },
    verEnvioMensajes() {
      if (this.selected && this.selected.length > 0) {
        this.$router.push("/AnalisisDeFormulario/EnvioDeMensajes");
        this.enviarMensajeCerrado = false;
        if (screen.width <= 1366) {
          this.tamanoPantalla = false;
        }
      }
    },
    async consultarProgramas() {
      try {
        this.$store.dispatch("setCargando", true);
        this.arrayEstadosSeleccionados = [];
        const respuesta = await obtenerProgramas();
        if (respuesta && respuesta.data && respuesta.data.data) {
          this.programas = respuesta.data.data;
        } else {
          console.error("No fue posible obtener los programas");
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    async consultarEstadosPrograma() {
      try {
        this.$store.dispatch("setCargando", true);
        this.arrayEstadosSeleccionados = [];
        const respuesta = await obtenerEstadosPrograma(
          this.programaSeleccionado.tipo_esquema
        );
        if (respuesta && respuesta.data && respuesta.data.data) {
          this.estadosPrograma = respuesta.data.data;
        } else {
          console.error("No fue posible obtener los estados del programa");
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    async consultarPacientesPrograma() {
      this.limpiarSelects(1);
      try {
        this.$store.dispatch("setCargando", true);
        const respuesta = await leerPacientesPrograma(
          this.programaSeleccionado.tipo_esquema,
          this.arrayEstadosSeleccionados
        );
        if (
          respuesta &&
          respuesta.data &&
          respuesta.data.data &&
          respuesta.data.data.pacientes
        ) {
          this.pacientesPrograma = respuesta.data.data.pacientes;
          await this.consultarColecciones();
        } else {
          console.error("No fue posible obtener los pacientes del programa");
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    async consultarColecciones() {
      try {
        this.$store.dispatch("setCargando", true);
        const respuesta = await obtenerColecciones();
        if (respuesta && respuesta.data && respuesta.data.data) {
          this.colecciones = respuesta.data.data;
        } else {
          console.error("No fue posible obtener las colecciones");
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    async consultarDocumentosColeccion() {
      this.limpiarSelects(2);
      try {
        this.$store.dispatch("setCargando", true);
        const respuesta = await obtenerDocumentosColeccion(
          this.coleccionSeleccionada.coleccion
        );
        if (respuesta && respuesta.data && respuesta.data.data) {
          this.documentosEnColeccion = respuesta.data.data;
        } else {
          console.error("No se pudo obtener los DocumentosColeccion");
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    async consultarVariablesDocumento() {
      this.limpiarSelects(3);
      try {
        this.$store.dispatch("setCargando", true);
        const respuesta1 = await clasificarPacientes(
          this.coleccionSeleccionada.coleccion,
          this.documentoSeleccionado.tipo_esquema,
          this.pacientesPrograma,
          this.fechaInicial,
          this.fechaFinal
        );
        if (
          respuesta1 &&
          respuesta1.data &&
          respuesta1.data.data &&
          respuesta1.data.data.categorizacion
        ) {
          this.categorizacion = respuesta1.data.data.categorizacion;
          const respuesta = await variablesDocumento(
            this.coleccionSeleccionada.coleccion,
            this.documentoSeleccionado.tipo_esquema
          );
          if (respuesta && respuesta.data && respuesta.data.data) {
            this.variablesDocumento = respuesta.data.data;
          } else {
            console.error("No se pudo obtener las variables del documento");
          }
        } else {
          console.error(
            "No fue posible realizar la categorización de los pacientes"
          );
        }
      } finally {
        this.$store.dispatch("setCargando", false);
        this.banderaMostrarSidebar = false;
      }
    },
    valorBanderaSidebar() {
      this.banderaMostrarSidebar = !this.banderaMostrarSidebar;
      this.graficaKey += 1;
      // this.datosGrafica +=1;
    },
    forceRerender() {
      this.graficaKey += 1;
    },
    async consultarAnalisisFormulario(data) {
      try {
        this.arrayVariablesTabla = data.arrayVariablesTabla;
        this.variableSeleccionada = data.variableSeleccionada;
        this.estadoDocumentos = data.estadoDocumentos;
        this.$store.dispatch("setCargando", true);
        this.desserts = [];
        this.selected = [];
        this.tituloPadre =
          this.estadoDocumentos === "diligenciados"
            ? `${
                this.variablesDocumento.filter(
                  v => v.valor === this.variableSeleccionada
                )[0].nombre
              }`
            : null;
        this.selectAll = false;
        if (this.estadoDocumentos === "diligenciados") {
          const consulta = {
            tipo_esquema: this.documentoSeleccionado.tipo_esquema,
            variables: this.arrayVariablesTabla
          };
          const respuesta = await analisisFormulario(
            this.coleccionSeleccionada.coleccion,
            this.fechaInicial,
            this.fechaFinal,
            this.categorizacion.diligenciados,
            consulta,
            this.variableSeleccionada
          );
          if (respuesta) {
            this.respuesta = respuesta;
            this.getGraphicData(this.respuesta);
          } else {
            console.error("No se obtuvo respuesta de análisis de formulario");
          }
        } else if (this.estadoDocumentos === "no_diligenciados") {
          const respuesta = await analisisFormulario(
            this.coleccionSeleccionada.coleccion,
            this.fechaInicial,
            this.fechaFinal,
            this.categorizacion.no_diligenciados,
            null,
            null
          );
          if (respuesta && respuesta.data && respuesta.data.data) {
            this.mostrarTablaNoDiligenciados(
              "No diligenciados",
              respuesta.data.data.headers,
              respuesta.data.data.usuarios
            );
          }
        }
      } finally {
        this.$store.dispatch("setCargando", false);
        // this.forceRerender();
        // this.graficaKey +=1;
        console.log(this.graficaKey);
      }
    },
    calcularCantidadSeleccionada(arrayValores) {
      let maximaLongitud = 0;
      arrayValores.map(variable => {
        if (variable.length >= maximaLongitud) {
          maximaLongitud = variable.length;
          if (maximaLongitud >= 7) {
            this.cantidaElementosMostrar = 0;
          } else if (maximaLongitud >= 4 && maximaLongitud < 7) {
            this.cantidaElementosMostrar = 1;
          } else {
            this.cantidaElementosMostrar = 2;
          }
        }
      });
      return arrayValores;
    },
    getGraphicData(response) {
      const maximo = Math.max.apply(null, response.data.data.series);
      const max = maximo + 1;
      this.series = [{ data: response.data.data.series, name: "" }];
      this.opciones = {
        ...this.opciones,
        ...{
          xaxis: {
            categories: response.data.data.ejex.map(e =>
              !e ? "Campo vacío" : e
            )
          }
        }
      };
      this.banderaTabla = false;
    },
    showTable(index) {
      try {
        this.selected = [];
        this.itemsPerPage = 15;
        this.banderaTabla = true;
        this.desserts = this.respuesta.data.data.usuarios[index];
        this.headers = this.respuesta.data.data.headers;
        this.mostrarTituloActual = true;
        this.valorCampo = !this.respuesta.data.data.ejex[index]
          ? "Campo vacío"
          : this.respuesta.data.data.ejex[index];
        this.tituloPadre = `${
          this.variablesDocumento.filter(
            v => v.valor === this.variableSeleccionada
          )[0].nombre
        }`;
      } finally {
        setTimeout(() => {
          this.autoScroll("finalTabla", "cuerpoAnalisis", 0);
        }, 100);
      }
    },
    mostrarTablaNoDiligenciados(titulo, headers, usuarios) {
      this.itemsPerPage = 25;
      this.banderaTabla = true;
      this.desserts = usuarios;
      this.headers = headers;
      this.tituloPadre = titulo;
      this.mostrarTituloActual = false;
    },
    enviarMensaje() {
      const cedulas = this.selected.map(row => row.cedula);
    },
    limpiarSelects(etapa) {
      const LIMPIAR_DESDE_PROGAMAS = 1,
        LIMPIAR_DESDE_COLECCION = 2,
        LIMPIAR_DESDE_DOCUMENTO = 3,
        LIMPIAR_DESDE_ESTADO_DOCUMENTO = 4;
      this.arrayGraficas = [];
      this.banderaTabla = false;
      this.desserts = [];
      this.headers = [];
      this.tituloPadre = "";
      this.arrayVariablesTabla = [];
      this.variableSeleccionada = null;
      switch (etapa) {
        case LIMPIAR_DESDE_PROGAMAS:
          this.colecciones = [];
          this.coleccionSeleccionada = null;
          this.documentosEnColeccion = [];
          this.categorizacion = { diligenciados: [], no_diligenciados: [] };
          this.documentoSeleccionado = null;
          this.estadoDocumentos = null;
          this.variablesDocumento = [];
          this.series = [];
          break;
        case LIMPIAR_DESDE_COLECCION:
          this.documentosEnColeccion = [];
          this.categorizacion = { diligenciados: [], no_diligenciados: [] };
          this.documentoSeleccionado = null;
          this.estadoDocumentos = null;
          this.variablesDocumento = [];
          this.series = [];
          break;
        case LIMPIAR_DESDE_DOCUMENTO:
          this.estadoDocumentos = null;
          this.variablesDocumento = [];
          this.series = [];
          break;
        case LIMPIAR_DESDE_ESTADO_DOCUMENTO:
          this.opciones = {
            ...this.opciones,
            ...{
              xaxis: {
                categories: [],
                labels: {
                  style: {
                    colors: ["#646a6f"],
                    fontSize: "16px",
                    fontFamily: "Nunito, sans-serif"
                  },
                  min: 20
                }
              }
            }
          };
          this.series = [{ data: [] }];
          break;
        default:
          break;
      }
    }
  }
};
</script>
<style src="./AnalisisDeFormulario.scss" lang="scss" scoped></style>

<style  lang="scss">
.contenedorAnalisisFormularios {
  .grafica_gestion {
    .apexcharts-canvas {
      max-width: 100%;
      svg {
        width: 100% !important;
        foreignObject {
          width: 100%;
        }
        g {
          width: 100%;
        }
      }
    }
  }
}
// .contenedorAnalisisFormularios {
//   .tablaPacientes {
//     .v-data-table-header{
//       th {
//         font-size: 16px;
//       }
//     }
//   }
//   .autocomplete {
//     margin-top: 12px;
//     .v-input__control {
//       .v-input__slot {
//         background-color: #f3f3f3 !important;
//         .v-select__slot {
//           input {
//             color: #2d2d2d !important;
//             font-weight: 600;
//           }
//           .mdi-menu-down::before {
//             color: #3a899a !important;
//             height: 28px;
//             font-size: 28px;
//           }
//         }
//       }
//       .v-text-field__details {
//         padding-left: 3%;
//       }
//     }
//   }
//   .autocomplete-llenado {
//     .v-input__control {
//       .v-input__slot {
//         background-color: #d9edf0 !important;
//         .v-select__slot {
//           input {
//             color: #575757 !important;
//             font-weight: 600;
//           }
//           .mdi-menu-down::before {
//             color: #575757 !important;
//             height: 28px;
//             font-size: 28px;
//           }
//         }
//       }
//       .v-text-field__details {
//         padding-left: 3%;
//       }
//     }
//   }
//   .autocomplete-deshabilitado {
//     .v-input__control {
//       .v-input__slot {
//         background-color: #f3f3f3 !important;
//         .v-select__slot {
//           input {
//             color: #2d2d2d !important;
//           }
//           .mdi-menu-down::before {
//             color: #666666 !important;
//             height: 28px;
//             font-size: 28px;
//           }
//         }
//       }
//       .v-text-field__details {
//         padding-left: 3%;
//       }
//     }
//   }
//   .cambioColor {
//     .v-input__slot {
//       background-color: #e0e0e0;
//       // input {
//       //   color: white !important;
//       // }
//       // .v-select__selection {
//       //   color: white !important;
//       // }
//       // .v-input__append-inner .v-input__icon i {
//       //   color: white !important;
//       // }
//     }
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/AnalisisDeFormulario/AnalisisDeFormulario.vue